import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import Swal from 'sweetalert2';
declare var $:any;

@Component({
  selector: 'app-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.scss']
})
export class RequestComponent {

  public dataListing:any=[];
  public loading:boolean = true;
  public loginDetail:any =[];
  public totalCount: number = 0;
  public p = 1;
  public pageLimit = 10;
  public previousLabel:any='';
  public nextLabel:any='';
  public searchKey:any='';
  
  constructor(public router: Router, public service: GlobalService) { 
    this.loginDetail = JSON.parse(localStorage.getItem('hva_login') || "{}");   
    this.getDetail(1);
   }

  ngOnInit(): void {
  }

     getDetail(page:any){       
      this.loading=true;
      this.service.GetApi('/email').subscribe(((response:any)=>{
        if(response.success ==1) {  
          var self =this;  
          this.loading=false;
          this.dataListing=response.data;
          this.totalCount =response.data.length;
        } else {
          this.dataListing=[];
          this.totalCount =0;
          this.loading=false;
        }
      }), (error) => { this.loading =false; });
    }

    reset(){
      this.searchKey='';
      this.getDetail(1);
    }
  

    redirect(data:any){
      // localStorage.setItem('hva_messageView',JSON.stringify(data));
      // this.router.navigate(['/inquiry-detail']);
    }

}
